import VoteModalContainer from './VoteModalContainer';

export default VoteModalContainer;
